const fontstyle1 = {
    fontFamily: '"Titillium Web", sans-serif'
  };

  const fontstyle2 ={
      fontFamily: '"Montserrat Alternates", sans-serif'
  }
  export { fontstyle1,fontstyle2};